__turbopack_context__.v({
  "carousel": "HeroSection-module__pmxDRG__carousel",
  "carouselItem": "HeroSection-module__pmxDRG__carouselItem",
  "carouselItems": "HeroSection-module__pmxDRG__carouselItems",
  "content": "HeroSection-module__pmxDRG__content",
  "description": "HeroSection-module__pmxDRG__description",
  "head": "HeroSection-module__pmxDRG__head",
  "imgContainer": "HeroSection-module__pmxDRG__imgContainer",
  "label": "HeroSection-module__pmxDRG__label",
  "marquee": "HeroSection-module__pmxDRG__marquee",
  "root": "HeroSection-module__pmxDRG__root",
  "tag": "HeroSection-module__pmxDRG__tag",
});
